import apiClient from "services/apiClient";

async function editConditions(id: any, data: any) {
  const url = `/admin/conditions/${id}`;
  const res = await apiClient.put(url, data);
  return res.data;
}

export default editConditions;
